module.exports = __webpack_public_path__ + "img/very_pale_white.6d644f4b.svg";